<!--<p>organisations-by-education-type-and-organisation works!</p>-->

<div *ngIf="period && organisations && organisations.length > 0" class="nav-content organisation-collection">
    <mat-nav-list>
        <div *ngFor="let organisation of organisations">
            <a mat-list-item routerLinkActive="active" routerLink="/{{globals.lang}}/perustutkintokoulutus/{{globals.toKebabCase(globals.getLocalizedValue(organisation.name))}}/{{educationTypeId}}/{{organisation.id}}" [queryParams]="{period: period}">{{globals.getLocalizedValue(organisation.name)}}</a>
         <!--{{globals.getLocalizedValue(organisation.name)}}-->
        </div>
    </mat-nav-list>
</div>